/* Copies text to the clipboard, falling back to the older copy command where the modern API is blocked. */
export const copyText = async (text: string): Promise<boolean> => {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text)
            return true
        }
    }
    catch {
        // Fall through to the older method below.
    }

    try {
        const area = document.createElement('textarea')

        area.value = text
        area.setAttribute('readonly', '')
        area.style.position = 'fixed'
        area.style.opacity = '0'

        document.body.appendChild(area)
        area.select()

        const copied = document.execCommand('copy')
        area.remove()

        return copied
    }
    catch {
        return false
    }
}

/* Uses the phone's share sheet when there is one, otherwise copies the text. */
export const shareText = async (input: { title: string, text: string }): Promise<'shared' | 'copied' | 'failed'> => {
    if (typeof navigator.share === 'function') {
        try {
            await navigator.share(input)
            return 'shared'
        }
        catch (error) {
            if (error instanceof DOMException && error.name === 'AbortError') return 'failed'
        }
    }

    return await copyText(input.text) ? 'copied' : 'failed'
}
